import { render, staticRenderFns } from "./EnrolmentPersonalInterest.vue?vue&type=template&id=55e670d9&scoped=true&"
import script from "./EnrolmentPersonalInterest.vue?vue&type=script&lang=js&"
export * from "./EnrolmentPersonalInterest.vue?vue&type=script&lang=js&"
import style0 from "./EnrolmentPersonalInterest.vue?vue&type=style&index=0&id=55e670d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e670d9",
  null
  
)

export default component.exports